import { FulfillmentGroupDataSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import * as z from "zod";
import { null as zNull } from "zod";

export const getMergeSuggestionSummaries = {
  name: "getMergeSuggestionSummaries" as const,
  input: zNull(),
  output: z.object({
    summaries: z.array(
      z.object({
        mergeSuggestionId: z.string(),
        groupCount: z.number(),
        groupIds: z.array(z.string()),
      }),
    ),
  }),
};

export const getMergeSuggestionGroups = {
  name: "getMergeSuggestionGroups" as const,
  input: z.object({ mergeSuggestionId: z.string() }),
  output: z.object({ groups: z.array(FulfillmentGroupDataSchema) }),
};
